import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { Modal, ModalHeader, ModalFooter } from 'reactstrap';
import './Tasks.css';
import store from '../../../stores/store';
import {
    TASK_NOT_COMMENCED_TXT,
    TASK_IN_PROGRESS_TXT,
    TASK_COMPLETE_TXT,
    TASK_ARCHIVED_TXT,
} from '../../../helpers/constants';

class TaskStatusDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            currentStatusInDropDown: this.setStatusClass(this.props.status),
            modal: false
        };
    }

    toggle = () => {
        this.setState({
            expanded: !this.state.expanded,
        });
    };

    //#region GET

    blockChangeStatus = (task, statusId) => {
        var isOffline = false;
        if (
            window.offlineApiExtension &&
            window.require &&
            !store.conn.isOnline
        ) {
            isOffline = true;
        }

        if (isOffline || (statusId === 6 && task.IsAdmin !== 1)) {
            return true;
        } else {
            // if user is GA or ASSAGNEE - enable
            if (task.IsAdmin === 1 || task.IsMyTask === 1) {
                return false;
            } else {    // if user is lead/chair and task privacy is lead/chair - enable
                if (task.IsLead === 1 && task.PrivacyId === 2) {
                    return false;
                }

                return true;
            }
        }
    };

    //#endregion GET

    //#region SET FUNCS

    setCurrentStatus(status) {
        if (status !== this.state.currentStatusInDropDown) {
            this.setState({ currentStatusInDropDown: status })
        }
    }

    setStatusClass = (status) => {
        if (this.props.setStatusClass) this.props.setStatusClass(status);
        return status.toLowerCase().replace(' ', '-');
    };

    changeState = async (statusId, statusName) => {



        var task = this.props.task;
        var statusText = '';

        if (this.state.currentStatusInDropDown !== statusName && !(this.blockChangeStatus(task, statusId))) {
            statusText = store.tasks.getStatusText(statusId);

            this.setCurrentStatus(statusText);
            this.setStatusClass(statusText);

            if (this.props.onChangeStatus) this.props.onChangeStatus(task.InstanceId, task.GroupId, task.TaskId, statusId);
        }

    };
    //#endregion SET

    //#region RENDER FUNCS

    renderDropdown = () => {
        const status = this.props.task.Status
        return (
            <div>
                <Dropdown dropup isOpen={this.state.expanded} toggle={this.toggle} toggle={this.toggle} status={status.toLowerCase().replace(' ', '-')}>
                    <DropdownToggle
                        className="btn btn-sm btn-outline-secondary dropdown-toggle " caret
                        style={{ border: 'none', color: 'white', marginTop: '-2px' }}>
                        <span className="pl-3" status={status.toLowerCase().replace(' ', '-')}>{status.charAt(0).toUpperCase() + this.props.task.Status.slice(1).replace('-', ' ')}</span>
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={this.changeState.bind(this, '0', 'Not commenced')} status="not-commenced">
                            <span status="not-commenced">{TASK_NOT_COMMENCED_TXT}</span>
                        </DropdownItem>
                        <DropdownItem onClick={this.changeState.bind(this, '2', 'In progress')} status="in-progress">
                            <span status="in-progress">{TASK_IN_PROGRESS_TXT}</span>
                        </DropdownItem>
                        <DropdownItem onClick={this.changeState.bind(this, '4', 'Complete')}>
                            <span status="complete">{TASK_COMPLETE_TXT}</span>
                        </DropdownItem>
                        {this.props.task.IsAdmin ?
                            <DropdownItem onClick={() => this.toggleModal()} >
                                <span status="archived">{TASK_ARCHIVED_TXT}</span>
                            </DropdownItem>
                            : null}
                    </DropdownMenu>
                </Dropdown>
                {this.renderModal()}
            </div>
        );
    };

    renderModal = () => {
        return (
            <Modal
                className="modal-lg"
                isOpen={this.state.modal}
                toggle={this.toggleModal}
                autoFocus={false}
            >
                <ModalHeader>
                    <p className="modal-title">
                    Archiving this task will remove it from your task list
                        </p>
                </ModalHeader>
                <ModalFooter>
                    <a
                        className="btn btn-outline-primary"
                        data-dismiss="modal"
                        onClick={() => this.toggleModal()}
                    >
                        Cancel
                        </a>
                    <LaddaButton
                        className="btn btn-primary"
                        onClick={() => this.changeState('6', 'archived')}
                        data-size={S}
                        data-style={SLIDE_LEFT}
                        data-spinner-size={30}
                        data-spinner-color="#fff"
                        data-spinner-lines={12}
                    >
                        Continue
                        </LaddaButton>
                </ModalFooter>
            </Modal>
        )
    }

    toggleModal = () => {
        this.setState({
            modal: !this.state.modal,
        })
    }

    renderStatic = () => {
        const status = this.props.task.Status
        return (
            <Dropdown dropup={true} isOpen={this.state.expanded} toggle={this.toggle} status={status.toLowerCase().replace(' ', '-')}>
                <DropdownToggle
                    className="btn btn-sm btn-outline-secondary"
                    disabled style={{ border: 'none', color: 'white', marginTop: '-2px' }}
                >
                    <span className="pl-3">
                        <span className="pl-3">
                            {status.charAt(0).toUpperCase() + status.slice(1).replace('-', ' ')}
                        </span>
                    </span>
                </DropdownToggle>
            </Dropdown>
        );
    };

    render() {
        if (!this.props.isStatic) {
            return this.renderDropdown();
        } else {
            return this.renderStatic();
        }
    }
}

//#endregion RENDER

TaskStatusDropdown.propTypes = {
    task: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
    onChangeStatus: PropTypes.func.isRequired,
    setStatusClass: PropTypes.func.isRequired,
    isStatic: PropTypes.bool.isRequired
};

export default TaskStatusDropdown;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Task/TaskStatusDropdown.js